import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
  card: {
    cursor: 'pointer',
    border: '1px solid transparent',
    '&:hover': {
      borderColor: theme.palette.primary.main,
      backgroundColor: theme.palette.accent.light,
      '& h6': {
        color: theme.palette.primary.main
      },
      '& div': {
        '& div': {
          backgroundColor: theme.palette.primary.disabled,
          color: theme.palette.primary.main
        }
      }
    },
    '&.selected': {
      transform: 'scale(1.05)',
      borderColor: theme.palette.primary.main,
      backgroundColor: theme.palette.accent.light,
      '& h6': {
        color: theme.palette.primary.main
      },
      '& div': {
        '& div': {
          backgroundColor: theme.palette.primary.disabled,
          color: theme.palette.primary.main
        }
      }
    }
  },
  layoutGrid: {
    width: '260px',
    height: '160px',
    display: 'grid',
    columnGap: '5px',
    rowGap: '5px'
  },
  title: {
    fontWeight: 'bold',
    fontSize: '15px',
    maxHeight: '33px',
    overflow: 'hidden',
    marginBottom: '10px'
  },
  placeholder: {
    backgroundColor: theme.palette.grey.medium,
    borderRadius: '4px',
    fontSize: '0.65rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.grey.dark,
    userSelect: 'none'
  },
  layoutA: {
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridTemplateRows: 'repeat(4, 1fr)',
    '& div:first-child': {
      gridRow: 'span 2'
    }
  },
  layoutB: {
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridTemplateRows: 'repeat(4, 1fr)',
    '& div:first-child': {
      gridRow: 'span 2'
    },
    '& div:nth-child(4)': {
      gridColumn: 'span 2'
    }
  },
  layoutC: {
    gridTemplateColumns: 'repeat(4, 1fr)',
    gridTemplateRows: 'repeat(4, 1fr)',
    '& div:first-child': {
      gridRow: 'span 2',
      gridColumn: 'span 2'
    },
    '& div:nth-child(4)': {
      gridColumn: 'span 2'
    }
  },
  layoutD: {
    gridTemplateColumns: 'repeat(4, 1fr)',
    gridTemplateRows: 'repeat(4, 1fr)',
    '& div:first-child': {
      gridRow: 'span 2',
      gridColumn: 'span 2'
    }
  },
  layoutE: {
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridTemplateRows: 'repeat(4, 1fr)',
    '& div:first-child': {
      gridRow: 'span 2'
    },
    '& div:nth-child(3)': {
      gridRow: 'span 2'
    }
  },
  layoutG: {
    gridTemplateColumns: 'repeat(5, 1fr)',
    gridTemplateRows: 'repeat(6, 1fr)'
  },
  layoutH: {
    gridTemplateColumns: 'repeat(4, 1fr)',
    gridTemplateRows: 'repeat(5, 1fr)'
  },
  layoutI: {
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridTemplateRows: 'repeat(5, 1fr)'
  },
  layoutJ: {
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridTemplateRows: 'repeat(5, 1fr)'
  },
  layoutK: {
    gridTemplateColumns: 'repeat(1, 1fr)',
    gridTemplateRows: 'repeat(5, 1fr)'
  },
  layoutL: {
    gridTemplateColumns: 'repeat(1, 1fr)',
    gridTemplateRows: 'repeat(1, 1fr)'
  },
  layoutN: {
    gridTemplateColumns: 'repeat(3, 1fr)',
    
    gridTemplateRows: 'repeat(4, 1fr)',
    '& div:first-child': {
      gridRow: 'span 2',
      gridColumn: 'span 2'
    },
  
    '& div:nth-child(3)': {
      gridRow: 'span 2',
      gridColumn: 'span 2'
    },
    '& div:nth-child(2)': {
      gridRow: 'span 2',
      gridColumn: 'span 1'
    },
    '& div:nth-child(4)': {
      gridRow: 'span 2',
      gridColumn: 'span 1'
    }
  },
  
  layoutO: {
    gridTemplateColumns: 'repeat(2, 1fr)',
    
    gridTemplateRows: 'repeat(2, 1fr)',
    '& div:first-child': {
      gridRow: 'span 1',
      gridColumn: 'span 1'
    },
  
    '& div:nth-child(3)': {
      gridRow: 'span 1',
      gridColumn: 'span 1'
    },
    '& div:nth-child(2)': {
      gridRow: 'span 1',
      gridColumn: 'span 1'
    },
    '& div:nth-child(4)': {
      gridRow: 'span 1',
      gridColumn: 'span 1'
    }
  }
}));

const LayoutPreview = ({ layout, isSelected, onSelect }) => {
  const classes = useStyles();

  const handleSelect = () => {
    onSelect(layout.id);
  };

  const renderPlaceholders = () =>
    [...Array(layout.slots)].map((_, index) => (
      <Box className={classes.placeholder}>{index + 1}</Box>
    ));

  return (
    <Grid key={layout.id} item xs={12} md={6}>
      <Box
        width="100%"
        p={1}
        borderRadius={5}
        className={`${classes.card} ${isSelected && 'selected'}`}
        bgcolor="#fff"
        onClick={handleSelect}
      >
        <Typography
          variant="subtitle1"
          className={classes.title}
          style={{ fontSize: '15px', maxHeight: '33px', overflow: 'hidden' }}
        >
          {layout.title}
        </Typography>
        <Box className={`${classes.layoutGrid} ${classes[layout.class]}`}>
          {renderPlaceholders()}
        </Box>
      </Box>
    </Grid>
  );
};

LayoutPreview.propTypes = {
  layout: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    slots: PropTypes.number.isRequired,
    class: PropTypes.string.isRequired
  }).isRequired,
  isSelected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired
};

export default LayoutPreview;
